// extracted by mini-css-extract-plugin
module.exports = {"image":"Donation_image__27pXC","title":"Donation_title__1s4pb"};